import { ApolloClient } from 'apollo-client';
import { InMemoryCache, IntrospectionFragmentMatcher } from 'apollo-cache-inmemory';
import { ApolloLink } from 'apollo-boost';
import introspectionQueryResultData from '../../gql/typedefs/fragmentTypes.json';
import { createGraphqlLink, createAuthLink, createRetryLink } from './apolloLinks';

/* -------------------------------------------------------------------------- *
 * apolloService
 *
 * The raw Apollo Client, which is passed to ApolloProvider and can also be
 * used imperatively. See https://www.apollographql.com/docs/react/.
 * -------------------------------------------------------------------------- */

const fragmentMatcher = new IntrospectionFragmentMatcher( {
    introspectionQueryResultData
} );

// The `InMemoryCache` normalizes query response objects before it saves
// them to its internal data store.
export const apolloCache = new InMemoryCache( { fragmentMatcher } );

// Combine Apollo links into one link to provide to the client. Oddly enough,
// the order of these matter, so be mindful of that.
const link = ApolloLink.from( [
    createRetryLink(),
    createAuthLink(),
    createGraphqlLink(),
] );

export const apolloService = new ApolloClient( { cache: apolloCache, link } );
